/**
 * 鼠标路径生成工具
 * 兼容 Vercel 构建环境
 */

export interface Vector {
  x: number;
  y: number;
}

export type PathFunction = (start: Vector, end: Vector) => Vector[];

/**
 * 生成真人化的鼠标移动路径
 * 在 Vercel 构建环境中使用 fallback（简单线性插值）
 */
export const generateMousePath = (start: Vector, end: Vector): Vector[] => {
  // 尝试使用 ghost-cursor（仅在运行时）
  // 使用 webpackIgnore 注释避免构建时警告
  if (typeof window !== 'undefined' || typeof process !== 'undefined') {
    try {
      const ghostCursor = require(/* webpackIgnore: true */ 'ghost-cursor');
      return ghostCursor.path(start, end);
    } catch (error) {
      return createFallbackPath(start, end);
    }
  }
  
  // Fallback: 简单的线性插值
  return createFallbackPath(start, end);
};

/**
 * 创建简单的线性插值路径（fallback）
 */
const createFallbackPath = (start: Vector, end: Vector): Vector[] => {
  const result: Vector[] = [];
  const steps = 60;
  
  for (let i = 0; i <= steps; i++) {
    result.push({
      x: start.x + (end.x - start.x) * (i / steps),
      y: start.y + (end.y - start.y) * (i / steps),
    });
  }
  
  return result;
};
